<template>
	<div class="page">

			<div class="LoginBox">
				<div class="intro">
					<h1>🚀</h1>
					<h1>Let's get you started with a shiny new account:</h1>
					<p>New accounts come with a free 14 day trial period to let you take a look around and see how Configaro works. Enjoy!</p>
					<p>Already have an account? <router-link to="/login" >Login here</router-link>.</p>
				</div>
				<div class="main">
					<RegisterForm :autofocus="true" />
				</div>
			</div>

	</div>
</template>

<script>

	import RegisterForm from '../../forms/RegisterForm';

	export default {
		components : {RegisterForm},
	}

</script>